import { ReactElement } from 'react'
import Image from 'components/Image'
import { cn } from 'cn'
import { StaticImageData } from 'next/image'

type Props = {
  content: ReactElement
  imageContent?: ReactElement | null
  links?: ReactElement
  imageSrc: string | StaticImageData
  size?: 'tiny' | 'small' | 'medium' | 'large'
}

const HeroSection = ({
  content,
  imageContent,
  imageSrc,
  size = 'medium',
  links
}: Props) => {
  const heightClass = cn({
    'min-h-64 sm:min-h-[40vh]': size === 'tiny',
    'min-h-88 sm:min-h-[46vh]': size === 'small',
    'min-h-104 sm:min-h-[50vh]': size === 'medium',
    'min-h-112 sm:min-h-[54vh]': size === 'large'
  })
  return (
    <div className="relative w-full">
      <div
        className={cn(
          'flex relative sm:flex-row flex-col items-stretch',
          heightClass
        )}
      >
        {links && (
          <div className="absolute sm:hidden top-0 right-0 bottom-0 z-30">
            {links}
          </div>
        )}
        <div
          className={cn(
            'sm:w-1/2 w-full sm:relative absolute inset-0 sm:inset-auto',
            heightClass
          )}
        >
          {imageContent && (
            <div className="z-20 relative mt-20 mb-28">{imageContent}</div>
          )}
          <Image
            alt="truck image"
            className="object-cover object-center"
            layout="fill"
            sizes="50vw"
            src={imageSrc}
            priority
          />
          <div
            className={cn('w-full h-full z-2 absolute top-0 left-0', {
              'bg-black/50': imageContent,
              'sm:bg-black/10 bg-black/60': !imageContent
            })}
          />
        </div>
        <div className="sm:bg-background-dark sm:w-1/2 w-full relative sm:static flex flex-col justify-end md:justify-center z-20 mt-auto sm:mt-0">
          <div className="sm:p-6 p-4 pr-14">{content}</div>
        </div>
      </div>
    </div>
  )
}

export default HeroSection
